<script setup>
defineProps({
  // [{ label, value, class?, trend? }]: trend is a number whose sign picks the arrow and the color
  items: {
    type: Array,
    required: true,
  },
})

const trendIcon = (trend) => {
  if (trend > 0) return { name: 'mdi-menu-up', color: 'positive' }
  if (trend < 0) return { name: 'mdi-menu-down', color: 'negative' }
  return { name: 'mdi-minus', color: 'grey-5' }
}
</script>

<template>
  <div class="grid-detail-info">
    <div v-for="item in items" :key="item.label">
      <div class="text-caption text-grey-7">{{ item.label }}</div>
      <div
        class="text-body2 text-weight-bold"
        :class="item.class ?? (item.trend !== undefined && `text-${trendIcon(item.trend).color}`)"
      >
        <q-icon
          v-if="item.trend !== undefined"
          :name="trendIcon(item.trend).name"
          :color="trendIcon(item.trend).color"
          size="xs"
        />
        {{ item.value }}
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.grid-detail-info {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
  gap: 1rem 2.5rem;
  align-content: center;
}

.grid-detail-info :slotted(.grid-detail-info__wide) {
  grid-column: span 2;
  min-width: 0;
}
</style>
